import TableRow from "@material-ui/core/TableRow";
import {TableBody, TableCell} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import React from "react";
import {useTranslation} from "react-i18next";

const TagRow = ({
                    name,
                    value,
                    handleDelete
                }: any) => {
    const edit = (key: any) => handleDelete(key);

    return (
        <TableRow key={name}>
            <TableCell style={{whiteSpace: 'normal', wordWrap: 'break-word', wordBreak: 'break-all'}}>{name}</TableCell>
            <TableCell style={{whiteSpace: 'normal', wordWrap: 'break-word', wordBreak: 'break-all'}}
                       align="center">{value}</TableCell>
            <TableCell align="right">
                <IconButton aria-label="delete" onClick={() => edit(name)}>
                    <DeleteIcon fontSize="small"/>
                </IconButton>
            </TableCell>
        </TableRow>
    );
}

export const MachineTagList = ({
                                   tags,
                                   handleDelete,
                                   onLoading
                               }: any) => {
    const {t} = useTranslation();
    return (
        <div style={{overflow: "auto", marginTop: '20px'}}>
            <div style={{overflow: 'auto'}}>
                <Table size="small" aria-label="tag table" stickyHeader={true}>
                    <TableHead>
                        <TableRow>
                            <TableCell align="left">
                                <label>
                                    {t('_Common.Labels.Name')}
                                </label>
                            </TableCell>
                            <TableCell align="center">
                                <label>
                                    {t('_Common.Labels.Value')}
                                </label>
                            </TableCell>
                            <TableCell align="right">
                                <label>
                                    {t('_Common.Labels.Edit')}
                                </label>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tags.map((tag: any) => <TagRow key={tag.key} name={tag.key} value={tag.value}
                                                      handleDelete={handleDelete}
                                                      onLoading={onLoading}/>)}
                    </TableBody>
                </Table>
            </div>
        </div>
    );
}
